var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-card mb-4"},[_c('div',{staticClass:"content-card-title"},[_vm._v("รอผลออก")]),_c('div',{staticClass:"content-card-body"},[_c('h2',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.qtyInprocess))])])])}
var staticRenderFns = []

export { render, staticRenderFns }